import { newsline } from "@/mocks/trending";

export default function Newsline() {
  return (
    <section id="news" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16 lg:px-14">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-rss-fill" aria-hidden="true"></i> 实时简报
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            疯传现场 <span className="text-primary-500">时间线</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">重大传播事件发酵的关键节点，我们帮你串成一条完整的线索。</p>

          <ol className="relative mt-8 space-y-0 border-l border-background-300 pl-6">
            {newsline.map((n, i) => (
              <li key={i} className="relative pb-8 last:pb-0">
                <span className="absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500 ring-2 ring-primary-200"></span>
                <span className="rounded-full bg-background-50 px-2.5 py-0.5 text-xs font-medium text-primary-700">{n.time}</span>
                <h3 className="mt-2 text-base font-semibold text-foreground-950 md:text-lg">{n.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{n.text}</p>
              </li>
            ))}
          </ol>
        </div>

        <div className="flex flex-col gap-6 lg:col-span-5">
          <div className="relative flex flex-1 flex-col justify-center overflow-hidden rounded-2xl bg-secondary-500 p-7 text-background-50">
            <div className="absolute -right-10 -top-10 h-36 w-36 rounded-full bg-background-50/15"></div>
            <i className="ri-megaphone-fill text-3xl text-accent-300" aria-hidden="true"></i>
            <h3 className="mt-4 font-heading text-xl font-bold text-background-50">重大事件 24 小时响应</h3>
            <p className="mt-3 text-sm leading-relaxed text-background-50/90">
              当一场传播真正「爆了」，我们会第一时间启动跟进：核实来源、标注时间线、拆分情绪点，避免断章取义带偏节奏。
            </p>
            <a href="#faq" className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-accent-200 hover:text-accent-100">
              了解我们的内容原则 <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
            <div className="flex items-center gap-2">
              <i className="ri-verified-badge-fill text-accent-600 text-lg" aria-hidden="true"></i>
              <h3 className="font-heading text-base font-bold text-foreground-950">我们坚持的四件事</h3>
            </div>
            <ul className="mt-4 space-y-3">
              {[
                ["核实优先", "先查来源再写稿，反转内容明确标注"],
                ["考据尊重", "还原梗的最初语境，不贴二手标签"],
                ["视角多元", "不止一面之词，尽量呈现多方说法"],
                ["吃瓜有度", "不造谣、不网暴、不渲染对立"],
              ].map(([t, d]) => (
                <li key={t} className="flex gap-3 text-sm">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                    <i className="ri-check-line text-xs" aria-hidden="true"></i>
                  </span>
                  <span>
                    <strong className="font-semibold text-foreground-950">{t}</strong>
                    <span className="text-foreground-600"> — {d}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}